import React, { useState, useEffect, useRef } from "react";
import "./AboutStats.css";
import CountUp from "react-countup";
import CEO from "../../assets/kemariceo.png";
import HR from "../../assets/hrofficer.png";
import ACC from "../../assets/accountingofficer.png";
import ADMIN from "../../assets/Admin.png";
import CAD from "../../assets/cad.png";
import DRIVER from "../../assets/driver.png";
import HEAD from "../../assets/head.png";
import PERSONNEL from "../../assets/personnel.png";
import SURVEYOR from "../../assets/quantitysurveyor.png";
import SITE1 from "../../assets/site1.png";
import SITE2 from "../../assets/site2.png";
import SUPERVISOR from "../../assets/superviser.png";
import Services from "../../components/home/Services";

import kemaribotbg from "../../assets/kemaribotbg.png";
import highlights1 from "../../assets/projectsimgs/llcAdmin4.png";
import highlights3 from "../../assets/featuredimgs/highlights2.png";
import highlights4 from "../../assets/featuredimgs/highlights4.png";

const mvvData = [
  {
    label: "01",
    title: "Mission",
    body: "Our mission is to provide protection and security to our clients through a bespoke service tailored to their specific needs, ultimately the safety and security of the client's staff, premises, assets and the general public is our highest priority.",
  },
  {
    label: "02",
    title: "Vision",
    body: "We are committed to the ongoing improvement of the services we provide to our clients. By investing in and developing our most important assets, our staff we aim to achieve all our goals and exceed our clients expectations. Through our commitment to high standards it is our vision to eam the trust of our clients by delivering the best quality security services within the Philippines.",
  },
  {
    label: "03",
    title: "Values",
    body: "As a company and as individuals we value above all else honesty. integrity, unselfishness. professionalism and mutual respect. For our staff, we offer a rewarding and challenging environment where personal development can flourish. We hold ourselves accountable to our clients, staff and partners by honouring our commitments providing results and continually striving to provide the highest quality security services",
  },
];

const teamMembers = [
  { img: CEO,        name: "Loreke V. Burbos",       role: "CEO / President" },
  { img: HR,         name: "Ferdilisa V. Sulat",      role: "HR Officer" },
  { img: ACC,        name: "Donabel V. Tapdasan",     role: "Accounting Officer" },
  { img: ADMIN,      name: "Maria Fatima B. Tapic",   role: "Admin / Purchasing" },
  { img: DRIVER,     name: "Rosauro T. Sabellon",     role: "Purchasing Driver" },
  { img: SURVEYOR,   name: "Rachel Marie L. Miranda", role: "Quantity Surveyor" },
  { img: SUPERVISOR, name: "Ramil Handumon",          role: "Project Supervisor" },
  { img: CAD,        name: "Jogie Anne T. Candol",    role: "CAD Operator" },
  { img: SITE2,      name: "Princess Lea Canlas",     role: "Site Engineer — Paseo" },
  { img: SITE1,      name: "Reynzo N. Olila",         role: "Site Engineer — Vertex" },
  { img: HEAD,       name: "Mario L. Aparis",         role: "Technical Head" },
  { img: PERSONNEL,  name: "Angelito N. Abalo",       role: "Technical Personnel" },
];

/* ── Reusable hook: fires once when element enters viewport ── */
function useInView(threshold = 0.15) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setInView(true); obs.disconnect(); } },
      { threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, inView];
}

function AboutStats() {
  /* ── Carousel ── */
  const rawImages = [kemaribotbg, highlights1, highlights3, highlights4];
  const images = rawImages.filter(Boolean);
  const [imgIndex, setImgIndex] = useState(0);

  useEffect(() => {
    images.forEach((src) => { const i = new Image(); i.src = src; });
  }, [images]);

  useEffect(() => {
    if (!images.length) return;
    const t = setInterval(() => setImgIndex((p) => (p + 1) % images.length), 5000);
    return () => clearInterval(t);
  }, [images]);

  /* ── CountUp ── */
  const [statsRef, statsInView] = useInView(0.3);

  /* ── Section in-view refs ── */
  const [heroTextRef,  heroTextInView]  = useInView(0.15);
  const [carouselRef,  carouselInView]  = useInView(0.15);
  const [mvvRef,       mvvInView]       = useInView(0.1);
  const [teamRef,      teamInView]      = useInView(0.08);

  /* ── Team toggle ── */
  const [showAllTeam, setShowAllTeam] = useState(false);

  return (
    <section id="about" className="as-root">

      {/* ═══ STATS ══ */}
      <div className="as-stats" ref={statsRef}>
        {[
          { end: 98,  suffix: "%", label: "Customer satisfaction" },
          { end: 50,  suffix: "+", label: "Projects completed" },
          { end: 99,  suffix: "+", label: "Skilled personnel" },
          { end: 10,  suffix: "+", label: "Years of experience" },
        ].map((s, i) => (
          <div className="as-stat" key={i}>
            <span className="as-stat-num">
              {statsInView
                ? <CountUp end={s.end} duration={2.5} suffix={s.suffix} />
                : `0${s.suffix}`}
            </span>
            <span className="as-stat-label">{s.label}</span>
          </div>
        ))}
      </div>

      {/* ═══ HERO TEXT ══ */}
      <div
        ref={heroTextRef}
        className={`as-hero-text as-animate${heroTextInView ? " as-in" : ""}`}
      >
        <p className="as-eyebrow">About Kemari</p>
        <h2 className="as-headline">
          Where strong systems power<br />smarter operations.
        </h2>
        <p className="as-body">
          Kemari is a systems integration company building dependable technology
          infrastructures for businesses and institutions. We plan, install, and
          maintain the environments that keep modern operations secure and running —
          from structured cabling and CCTV to PABX and all auxiliary works.
        </p>
      </div>

      {/* ═══ CAROUSEL IMAGE ══ */}
      <div
        ref={carouselRef}
        className={`as-carousel-wrap as-animate-scale${carouselInView ? " as-in" : ""}`}
      >
        <div
          className="as-carousel"
          style={{ backgroundImage: `url(${images[imgIndex]})` }}
        />
        <div className="as-carousel-dots">
          {images.map((_, i) => (
            <button
              key={i}
              className={`as-dot${i === imgIndex ? " active" : ""}`}
              onClick={() => setImgIndex(i)}
            />
          ))}
        </div>
      </div>

      {/* ═══ MVV ══ */}
      <div
        ref={mvvRef}
        className={`as-mvv${mvvInView ? " as-mvv-in" : ""}`}
      >
        <p className="as-eyebrow">Our foundation</p>
        <div className="as-mvv-grid">
          {mvvData.map((m, i) => (
            <div
              className="as-mvv-card as-animate"
              key={m.label}
              style={{ "--i": i }}
            >
              <span className="as-mvv-num">{m.label}</span>
              <h3 className="as-mvv-title">{m.title}</h3>
              <p className="as-mvv-body">{m.body}</p>
            </div>
          ))}
        </div>
      </div>

      {/* ═══ FEATURED PROJECTS ══ */}
      <Services />

      {/* ═══ TEAM ══ */}
      <div
        id="team"
        ref={teamRef}
        className={`as-team${teamInView ? " as-team-in" : ""}`}
      >
        <div className="as-team-header">
          <div className="as-team-header-row">
            <div>
              <p className="as-eyebrow">The people</p>
              <h2 className="as-headline">Meet our team.</h2>
            </div>
            <button
              className="as-team-toggle"
              onClick={() => setShowAllTeam((prev) => !prev)}
            >
              {showAllTeam ? "Show less" : "View all"}
              <span className={`as-team-toggle-icon${showAllTeam ? " open" : ""}`} />
            </button>
          </div>
        </div>

        <div className="as-team-grid">
          {(showAllTeam ? teamMembers : teamMembers.slice(0, 4)).map((m, i) => (
            <div
              className="as-team-card as-animate"
              key={i}
              style={{ "--i": i }}
            >
              <div className="as-team-img-wrap">
                <img src={m.img} alt={m.name} />
              </div>
              <p className="as-team-name">{m.name}</p>
              <p className="as-team-role">{m.role}</p>
            </div>
          ))}
        </div>
      </div>

    </section>
  );
}

export default AboutStats;